import { Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { Image, PageFooter, Title } from "@src/appV2/redesign/system/ui-components";
import { PageContent } from "@src/appV2/redesign/WorkerShifts/components/PageContent";
import { useState } from "react";

import { BadgePolicyCards } from "./BadgePolicyCards";

interface WorkBadgeReviewPolicyProps {
  onClose: () => void;
  onNeedNewBadge: () => void;
}

export function WorkBadgeReviewPolicy(props: WorkBadgeReviewPolicyProps) {
  const { onClose, onNeedNewBadge } = props;

  const [activeStep, setActiveStep] = useState(0);
  const totalSteps = 2;

  const isLastStep = activeStep === totalSteps - 1;

  return (
    <>
      <StickyScrollPageHeader title="" headerVariant="tertiary" onClickBack={onClose} />

      <PageContent>
        <Stack alignItems="center" spacing={3}>
          <Stack alignItems="center">
            <Title component="h3">Badge Required</Title>
            <Title component="h3">Workplace Policy</Title>
          </Stack>

          <Image src="/assets/images/work-badge.png" alt="Work Badge" />

          <BadgePolicyCards activeStep={activeStep} setActiveStep={setActiveStep} />
        </Stack>
      </PageContent>

      <PageFooter>
        <Stack alignItems="center" spacing={4} width="100%">
          <Stack direction="row" spacing={3} width="100%">
            <Button
              fullWidth
              variant="outlined"
              onClick={() => {
                onClose();
              }}
            >
              Back
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                if (isLastStep) {
                  logEvent(APP_V2_USER_EVENTS.WORK_BADGE_REVIEW_POLICY_COMPLETED);
                  onClose();
                } else {
                  setActiveStep(activeStep + 1);
                }
              }}
            >
              {isLastStep ? "Done" : "Next"}
            </Button>
          </Stack>

          <TextButton
            size="large"
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.WORK_BADGE_NEED_NEW_BADGE_CLICKED);
              onNeedNewBadge();
            }}
          >
            Need a new badge?
          </TextButton>
        </Stack>
      </PageFooter>
    </>
  );
}
